import { render } from "./DefaultSettingPage.vue?vue&type=template&id=601b53f2"
import script from "./DefaultSettingPage.vue?vue&type=script&lang=js"
export * from "./DefaultSettingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__